<template>
    <div>
        <h2
            class="cms-content-heading cms-content-our-range__title cms-content-our-range__title--desktop"
        >
            {{ title }}
        </h2>
        <slot></slot>

        <button
            v-on:click.prevent="openMobileFilters = !openMobileFilters"
            class="cms-content-our-range-filter__mobile-filter-btn cms-content-our-range-filter__button btn btn--full-width"
            :class="{ 'cms-content-our-range-filter__button--active': openMobileFilters }"
        >
            Filter
        </button>

        <div
            class="cms-content-our-range-filter__group"
            :class="{ 'cms-content-our-range-filter__group--open': openMobileFilters }"
        >
            <select-dropdown
                option-key="brand"
                id="brandSelect"
                :event="{ category: 'Electric Model Search', label: 'Brand Clicked' }"
            >
                Brand
            </select-dropdown>
            <select-dropdown
                option-key="bodystyle"
                id="bodySelect"
                :event="{ category: 'Electric Model Search', label: 'Body Type Clicked' }"
            >
                Body type
            </select-dropdown>

            <min-max-slider-dropdown
                id="budgetDropRange"
                min-key="minPrice"
                max-key="maxPrice"
                :step="500"
                :financial="true"
                v-if="initialized && showMinMaxSlider"
                :event="{ category: 'Electric Model Search', label: 'Budget Clicked' }"
            >
                Price
            </min-max-slider-dropdown>

            <min-max-slider-dropdown
                id="evRangeDropRange"
                min-key="minRange"
                max-key="maxRange"
                :step="25"
                :financial="false"
                v-if="initialized && showMinMaxSlider"
                :event="{ category: 'Electric Model Search', label: 'Range Clicked' }"
            >
                Battery range
            </min-max-slider-dropdown>

            <!-- <slider-dropdown
                id="budgetDropRange"
                min-key="minPrice"
                max-key="maxPrice"
                :step="500"
                :financial="true"
            >
                Price
            </slider-dropdown>

            <slider-dropdown
                id="rangeDropRange"
                min-key="minRange"
                max-key="maxRange"
                :step="25"
            >
                Battery range
            </slider-dropdown> -->

            <button
                v-on:click="openMobileFilters = false"
                class="cms-content-our-range-filter__filter-close btn btn--primary btn--full-width"
            >
                Search
            </button>
        </div>

        <LoadingSpinner v-if="loadingVehicles" />
        <template v-else-if="computedVehicles.length > 0">
            <div class="cms-content-our-range__card-container" >
                <template v-for="vehicle in computedVehicles">
                    <vehicle-card v-if="vehicle.coming_soon == 0" :vehicle="vehicle" :key="vehicle.id"/>
                    <vehicle-coming-soon v-else :vehicle="vehicle" :key="vehicle.id" />
                </template>
            </div>
            <button
                v-on:click="showMoreVehicles = !showMoreVehicles"
                class="cms-content-our-range__show-all-vehicles btn btn--primary"
            >
                {{ showMoreVehicles ? "Show less" : "Show more" }}
            </button>
        </template>
        <div class="cms-content-our-range__no-results" v-else>
            <span
                >Sorry, we have no results which match your options. Please
                <button
                    v-on:click="resetFilters"
                    class="cms-content-our-range__no-results-button"
                >
                    reset your filters
                </button>
                and try again.</span
            >
        </div>
    </div>
</template>

<script>
import SelectDropdown from "./SelectDropdown.vue";
import MinMaxSliderDropdown from "./MinMaxSliderDropdown.vue";
import VehicleCard from "./VehicleCard.vue";
import VehicleComingSoon from "./VehicleComingSoon.vue";
import LoadingSpinner from '../../../used-vue/components/Buy-Online/LoadingSpinner.vue';
import { mapState } from "vuex";
import { MatchHeight } from "js-match-height";

export default {
    components: {
        SelectDropdown,
        MinMaxSliderDropdown,
        VehicleCard,
        VehicleComingSoon,
        LoadingSpinner
    },
    props: {
        title: String,
    },
    data() {
        return {
            openMobileFilters: false,
            showMinMaxSlider: true,
            showMoreVehicles: false,
        };
    },
    watch: {
        vehicles: {
            deep: true,
            immediate: false,
            handler: function (newValue) {
                if (newValue.length <= 0) {
                    return;
                }
                this.$nextTick(function () {
                    new MatchHeight(".cms-content-our-range__card .cms-content-slice__trim-name", { timeout:400 });
                });
            },
        },
    },

    created() {
        this.$store.dispatch("getOptionsAndVehicles");
    },
    computed: {
        ...mapState([
            'vehicles',
            'loadingVehicles',
            'initialized',
            'availableOptions'
        ]),

        computedVehicles() {
            if (!this.showMoreVehicles) {
                return this.vehicles.slice(0, 3);
            }

            return this.vehicles;
        }
    },
    methods: {
        resetFilters() {
            this.showMinMaxSlider = false;
            this.$store.commit("updateOptions", {
                brand: [],
                bodystyle: [],
                minPrice: this.availableOptions.minPrice,
                maxPrice: this.availableOptions.maxPrice,
                minRange: this.availableOptions.minRange,
                maxRange: this.availableOptions.maxRange,
            });
            this.$store.dispatch("getOptionsAndVehicles");
            this.$nextTick(function () {
                this.showMinMaxSlider = true;
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/our-range/OurRangeElectric.vue